export default {
  getTaxRate: (state) => state.taxRate,
  getTaxRateName: (state) => (taxType) => {
    console.log(taxType);
    return state.taxRates?.find((t) => t.taxType === taxType)?.name ?? taxType;
  },
};
